export default "/_next/static/fonts/IntercomBrand-Medium-3e2223c3b90852a47abd88feeada991d.woff";